import React from 'react';
export var WaitingDots = function WaitingDots() {
  return React.createElement("div", {
    className: "modal__waiting"
  }, React.createElement("span", {
    className: "modal__waiting-dot modal__waiting-dot--1"
  }), React.createElement("span", {
    className: "modal__waiting-dot modal__waiting-dot--2"
  }), React.createElement("span", {
    className: "modal__waiting-dot modal__waiting-dot--3"
  }), React.createElement("span", {
    className: "modal__waiting-dot modal__waiting-dot--4"
  }));
};